<template>

    <div class="last_evals_item">
        <div class="last_evals_item_cell username_cell">
            <router-link :to=" 'evaluations/' + evaluation.id ">
                <span>{{evaluation.candidate_username}}</span>
            </router-link>
            <span class="rec_db_eval_name" v-if="notOwnedEval">
                {{ evaluation.recruiter_name }}
            </span>
        </div>
        <div class="last_evals_item_cell position_cell">
            <span v-if="evaluation.sight_group_name">{{evaluation.sight_group_name}}</span>
            <span class="ref_name">{{ getRefName(evaluation.saven_test.sight_ref) }}</span>

        </div>
        <div class="last_evals_item_cell download_cell">
            <div v-if="!evaluation.in_regen">
                <div class="icon_cloud" @click="openEvalModal(evaluation.id)" v-if="evaluation.completed">
                    <i class="zmdi zmdi-cloud-download"></i>
                </div>

                <Modal
                    cancelLabel="Fermer"
                    :confirmLabel="false"
                    :isOpen="evalIsOpened(evaluation.id)"
                    modalTitle="Télécharger un rapport"
                    class="reports_eval_modal"
                    @onConfirm="onConfirm"
                    @onClose="onClose">

                    <div class="report_choices">
                        <div><a target="_blank" :href="evaluation.saven_test.expert_report_url">{{ $t('modules.dashboard.lastEvals.recruiterReport') }}</a></div>
                        <div><a target="_blank" :href="evaluation.saven_test.customer_report_url">{{ $t('modules.dashboard.lastEvals.customerReport') }}</a></div>
                        <div><a target="_blank" :href="evaluation.saven_test.passeport_report_url">{{ $t('modules.dashboard.lastEvals.passeportVIP') }}</a></div>
                    </div>

                </Modal>
            </div>
            <div v-else>
                <IconLoader class="icon_loader" />
            </div>

        </div>

    </div>

</template>

<script>
export default {
    name: 'LastEvalsItem',
    props: {
        evaluation: {
            required: true
        }
    },
    mounted(){
        this.checkReportsRegen()
    },
    data(){
        return {
            selectedTab: 'completed',
            openedEval: -1,
            intervalId: "",
            userData: JSON.parse(localStorage.getItem('account')).user
        }
    },
    computed: {
        notOwnedEval(){
            return this.userData.id != this.evaluation.user_id
        }
    },
    methods: {
        getRefName(refItem){
            if (refItem.ref_type == 'saven'){
                return this.$i18n.t("refs.jobs." + refItem.slug)
            }else{
                return refItem.name
            }
        },
        goEval(){
            this.$router.push("/evaluations/" + this.evaluation.id)
        },
        evalIsOpened(evalId){
            return this.openedEval == evalId
        },
        openEvalModal(evalId){
            this.openedEval = evalId
        },
        onClose(){
            this.openedEval = -1
        },
        onConfirm(){

        },
        checkReportsRegen(){
            this.intervalId = setInterval(() => {
                if (this.evaluation){
                    if (this.evaluation.in_regen){
                        this.$store.dispatch('EvalStore/indexEvals')
                    }
                }
            }, 5000)
        }

    },
    beforeDestroy () {
        clearInterval(this.intervalId)
    }
}


</script>

<style lang="scss">
.last_evals_item{
    display: flex;
    height: 60px;
    align-items: center;
    border-bottom: 1px solid $grey-lighter;
    background-color: $white-ter;
    .last_evals_item_cell{
        padding: 0 12px;
        display: flex;
    }
    .username_cell{
        width: 30%;
        font-weight: 500;
        flex-direction: column;
        align-items: flex-start;
        .rec_db_eval_name{
            color: $primary;
        }
    }
    .position_cell{
        width: 60%;
        flex-direction: column;
        align-items: flex-start;
        font-weight: 600;
        .ref_name{
            text-transform: uppercase;
            font-weight: 600;
            color: $grey-light;
        }
    }
    .download_cell{
        width: 10%;
        justify-content: flex-end;
        .icon_cloud{
            width: 32px;
            height: 32px;
            line-height: 32px;
            font-size: 1.5rem;
            cursor: pointer;
            &:hover{
                color: $info;
            }
        }
        .icon_loader{
            width: 25px;
        }
    }
    .edit_cell{
        width: 10%;
        justify-content: flex-end;
        .icon_edit{
            width: 32px;
            height: 32px;
            line-height: 32px;
            font-size: 1.5rem;
            cursor: pointer;
            &:hover{
                color: $info;
            }
        }
    }
}
</style>